import React, { memo } from "react";
import {FormBlocks} from './FormBlocks';
import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';
import { isSet } from "../../../../Utils/CommonFunctions";
import Icons from "../../../Icons/Icons";


const Email = (props)=>{
  const { 
    item,
    className,
    validationForms,
    fieldObj
  } = props;
  const attr = formFieldsAttributes(
    {...item,className:className
  },validationForms);
  
  //console.log('isSet(attr.value,',isSet(attr.value,'').split('.'))
  try{
    return (
      <FormBlocks {...props}  attr={attr}>
         <div className='form-control p-0 pt-0' style={{overflow:'hidden'}}>
                      <span className="text-truncate tag-wrapper ReactTags__tag cursor_pointer" title={''}  >
                          <a className="pr-1 cursor_pointer"  onClick={()=>item.removeHandler(item)}>
                              <Icons iconType='Delete' color='#cfd8dc' size={15} />
                          </a> 
                          {(isSet(props.item.isEditEnable,false)===true)?
                               <a className="pr-1 cursor_pointer" onClick={item.editHandler}>
                                  <Icons iconType='Edit' color='#cfd8dc' size={15} />
                               </a>
                          :<></>}
                         {attr.value}
                         {/* {isSet(attr.value,'').split('.').map((nam,ind)=>{
                          return(
                              <>
                                  <>{nam}</>
                                  <span className="separator"></span>
                                  {isSet(attr.value,'').split('.').length !== ind+1 ?
                                      <span className="separator"> 
                                          <Icons iconType={"SeperatorIcon"} color={'#fff'} size={10}/>
                                      </span>
                                  :<></>}
                          </>
                                                                                      
                        )}) */}
                  {/* } */}
                      </span>
              </div>
         
      </FormBlocks>
    );
  }catch(e){
    console.log('ee',e);
    return null
  }
  
}


Email.defaultProps = {
  className:'form-control'
};

const isDiffProps = (prevProps,nextProps)=>{
  if(prevProps.item.selectedValue===nextProps.item.selectedValue && prevProps.validationForms===nextProps.validationForms && prevProps.item.access_mode===nextProps.item.access_mode){
    return true;
  }
}

export default memo(Email,isDiffProps);
